import Api from './Api'
import WebMessage from './WebMessage'
import Model from './interface/Model'

export default class CreativeImportModule extends Model {
  protected api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'creative_imports' as string | null,
      plural: 'creative_imports' as string | null,
    },
  }

  public id: any = null

  public name = ''

  public advertiser_id: any = null

  public iscis: any = null

  public connection: any = 'extreme_reach'

  public status: any = null

  public imported_at: any = null

  public last_tried_at: any = null

  public next_retry_at: any = null

  public retry: any = null

  public last_error: any = null

  public batch_id: any = null

  public creative_id: any = null

  public get apiData() {
    return {
      advertiser_id: this.advertiser_id,
      iscis: this.iscis,
      connection: this.connection,
    }
  }

  public static async retry(import_ids: string[]) {
    const api = new Api()
    return api.post('creative_imports/retry', { import_ids }).then(response => response)
  }

  public onSave(response: any) {
    if ([200, 201].includes(response.status)) {
      WebMessage.success('Importing creative.')
    }
  }
}
